import React from 'react';

import { useAction } from '../action';

const useStable = <T extends any>(value: T): React.MutableRefObject<T> => {
  const ref = React.useRef<T>(value);
  ref.current = value;

  return ref;
};

export const useStablize = <T extends any>(value: T): [T, React.MutableRefObject<T>] => {
  return [value, useStable(value)];
};

export const useStableCb = <P extends any[], R>(
  callback: (...args: P) => R,
  deps: React.DependencyList
): ((...args: P) => R) => {
  const cb = useStable(React.useCallback(callback, deps));

  return React.useCallback((...args: P) => {
    return cb.current(...args);
  }, []);
};

export const useStableAction = <P extends any[], R>(
  callback: (...args: P) => R,
  deps: React.DependencyList
): ((...args: P) => R) => {
  const cb = useStable(useAction(callback, deps));

  return React.useCallback((...args: P) => {
    return cb.current(...args);
  }, []);
};

export default useStable;
